"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * An abstract actor that handles media-typed actions.
 *
 * It splits up a action between a 'handle' and a 'mediaTypes' action.
 * A 'mediaTypes' action is used to retrieve the available media types from this actor.
 * A 'handle' action is abstract, and can be implemented to do anything,
 * such as parsing, serializing, etc.
 * @see IActionAbstractMediaTyped
 *
 * @see ActorAbstractMediaTypedFixed
 */


var ActorAbstractMediaTyped =
/*#__PURE__*/
function (_core_1$Actor) {
  _inherits(ActorAbstractMediaTyped, _core_1$Actor);

  function ActorAbstractMediaTyped(args) {
    _classCallCheck(this, ActorAbstractMediaTyped);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorAbstractMediaTyped).call(this, args));
  }

  _createClass(ActorAbstractMediaTyped, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var typedAction;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!('handle' in action)) {
                  _context.next = 8;
                  break;
                }

                typedAction = action;
                _context.next = 4;
                return this.runHandle(typedAction.handle, typedAction.handleMediaType, action.context);

              case 4:
                _context.t0 = _context.sent;
                return _context.abrupt("return", {
                  handle: _context.t0
                });

              case 8:
                if (!('mediaTypes' in action)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 11;
                return this.getMediaTypes(action.context);

              case 11:
                _context.t1 = _context.sent;
                return _context.abrupt("return", {
                  mediaTypes: _context.t1
                });

              case 15:
                throw new Error('Either a handle or mediaType action needs to be provided');

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var typedAction;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!('handle' in action)) {
                  _context2.next = 8;
                  break;
                }

                typedAction = action;
                _context2.next = 4;
                return this.testHandle(typedAction.handle, typedAction.handleMediaType, action.context);

              case 4:
                _context2.t0 = _context2.sent;
                return _context2.abrupt("return", {
                  handle: _context2.t0
                });

              case 8:
                if (!('mediaTypes' in action)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 11;
                return this.testMediaType(action.context);

              case 11:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", {
                  mediaTypes: _context2.t1
                });

              case 15:
                throw new Error('Either a handle or mediaType action needs to be provided');

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function test(_x2) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }]);

  return ActorAbstractMediaTyped;
}(core_1.Actor);

exports.ActorAbstractMediaTyped = ActorAbstractMediaTyped;